/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Main_ContactInputs */

const en_clients_field_main_contact = /** @type {(inputs: Clients_Field_Main_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main contact`)
};

const pt_br2_clients_field_main_contact = /** @type {(inputs: Clients_Field_Main_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato principal`)
};

/**
* | output |
* | --- |
* | "Main contact" |
*
* @param {Clients_Field_Main_ContactInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_main_contact = /** @type {((inputs?: Clients_Field_Main_ContactInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Main_ContactInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_main_contact(inputs)
	return pt_br2_clients_field_main_contact(inputs)
});